import { render, staticRenderFns } from "./CartShippingCard.vue?vue&type=template&id=21ffc195&scoped=true&"
import script from "./CartShippingCard.vue?vue&type=script&lang=js&"
export * from "./CartShippingCard.vue?vue&type=script&lang=js&"
import style0 from "./CartShippingCard.vue?vue&type=style&index=0&id=21ffc195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ffc195",
  null
  
)

export default component.exports